import { Operator } from "@skilitics/judy";

import type { ConditionBuilder, ConditionBuilderContext, DesignerCondition } from "../../../types";
import { createConditionBuildable } from "../../conditions";
import { GROUP_CONDITION_CHILDREN_KEY, GROUP_CONDITION_NAME } from "../../constants";
import { GroupConditionEditor } from "./GroupConditionEditor";
import { GroupConditionSummary } from "./GroupConditionSummary";
import type { GroupOperator } from "./types";

type Config = { operator: GroupOperator };

interface Context extends ConditionBuilderContext {
  config: Config;
  children: {
    [GROUP_CONDITION_CHILDREN_KEY]: DesignerCondition[];
  };
}

export const groupConditionBuilder: ConditionBuilder<Context> = {
  typeId: GROUP_CONDITION_NAME,
  defaultCategory: "Utility",
  build: ({ config: { operator }, children: { values } }) => {
    const conditions = values
      .map((v) => ({
        type: "boolean",
        resolveType: "condition",
        condition: v.build(),
      }))
      .filter((v) => !!v.condition);
    if (conditions.length === 0) {
      return undefined; // nothing in it then no condition
    }
    return {
      type: "boolean",
      operator: Operator.EQ,
      subject: {
        type: "boolean",
        resolveType: operator === "all" ? operator : "any",
        [GROUP_CONDITION_CHILDREN_KEY]: conditions,
      },
      object: operator !== "none",
    };
  },
  getInitialConfig: () => ({
    operator: "all",
  }),
  getInitialChildren: () => ({
    [GROUP_CONDITION_CHILDREN_KEY]: [],
  }),
  views: {
    summary: GroupConditionSummary,
    edit: GroupConditionEditor,
  },
};

export const groupConditionBuildableCreate = () =>
  createConditionBuildable(groupConditionBuilder, GROUP_CONDITION_NAME, { title: "Group" });
